export default "__VITE_ASSET__65286f9d__"